import { NewsAbstraction, withCommonNews } from './NewsAbstract';

class NewsHome extends NewsAbstraction {

    protected renderNewsContent(): JSX.Element {
        const userObject = this.getUserObject();
        const config = this.props.appServices.config;

        return (
            <news-consumer
                user={JSON.stringify(userObject)}
                mfebaseurl={`${config.toxnotWebAppUrlEndpoint}/News/NewsSearch`}
                openedarticleurl={config.newsOpenedArticleUrl}
                bffurlparameter={config.newsBffBaseUrl}
                newsletterArchiveUrl={config.newsNewsletterArchiveUrl}>
            </news-consumer>
        );
    }
}

export default withCommonNews(NewsHome);